import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

@Component({
    selector: 'map-support-center',
    templateUrl: './support-center.component.html',
    styleUrls: ['./support-center.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportCenterComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {}

}